import BaseAPI from "@/api/BaseAPI";

export class FounderAPI extends BaseAPI{
    constructor() {
        super('/');
    }
    /**
     * @param {number} id
     */
    read(id) {
        return this.http.get('foiv/form2/founder', {data: {founderId : id}})
    }
    /**
     * @param {number} id
     */
    readSings(id) {
        return this.http.get('foiv/form2/founder/sign', {data: {founderId : id}})
    }
    /**
     * @param {number} rowId
     * @param {boolean} hasApproved
     */
    resolveRejectOffer(rowId, hasApproved){
        return this.http.put(`foiv/form2?rowId=${rowId}&hasApproved=${hasApproved}`,{})
    }
    /**
     * @param {number} id
     */
    getExcel(id){
        return this.http.get(`reports/getByAlias/FoivKcpReportNeArced?founderId=${id}`,{ responseType: 'blob' })
    }
}
export default new FounderAPI()